module.exports = __webpack_public_path__ + "static/media/mobile_frame.339bc6ba.png";